import { Spacing, Text } from '@vkontakte/vkui';
import React, { memo, useEffect } from 'react';
import { WhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog';

import { EXTEND_QUOTA_OFFER_PROPS_MAP } from './ExtendQuotaOfferModal.const';
import styles from './ExtendQuotaOfferModal.css';
import { getExtendQuotaOfferModalCoverImage } from './ExtendQuotaOfferModal.helpers';
import type { ExtendQuotaOfferModalProps } from './ExtendQuotaOfferModal.types';

export const ExtendQuotaOfferModal = memo<ExtendQuotaOfferModalProps>(({ onShow, onPrimaryClick, onSecondaryClick, onClose, onCancel }) => {
    useEffect(onShow, []);

    const { title, text, primaryActionText, secondaryActionText } = EXTEND_QUOTA_OFFER_PROPS_MAP;

    const coverUrl = getExtendQuotaOfferModalCoverImage();

    return (
        <WhatsNewDialog
            qaId="extend-quota-offer-modal-desktop"
            className={styles.root}
            primaryButtonText={primaryActionText}
            secondaryButtonText={secondaryActionText}
            title={title}
            imageUrl={coverUrl}
            content={
                <>
                    <Spacing size={12} />
                    <Text className={styles.text}>{text}</Text>
                    <Spacing size={24} />
                </>
            }
            dialogSize="tiny"
            buttonTheme="vk"
            onClick={onPrimaryClick}
            onSecondary={onSecondaryClick}
            onClose={onClose}
            onDismiss={onCancel}
            closeAfterClick
        />
    );
});

ExtendQuotaOfferModal.displayName = 'ExtendQuotaOfferModal';
